import { dataSwitch } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSwitch = /*#__PURE__*/createIcon(dataSwitch)
export default IconSwitch
